import React, { ComponentProps } from "react";

function PlayIconFlilled(props: ComponentProps<"svg">) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="ph:play-fill">
        <path
          id="Vector"
          d="M18.75 9.9999C18.7505 10.2121 18.6961 10.4208 18.5921 10.6058C18.488 10.7907 18.3379 10.9456 18.1562 11.0554L6.9 17.9413C6.71022 18.0575 6.49286 18.121 6.27037 18.1251C6.04788 18.1292 5.82832 18.0738 5.63438 17.9647C5.44227 17.8573 5.28225 17.7007 5.17075 17.5109C5.05926 17.3212 5.00032 17.1051 5 16.8851V3.11475C5.00032 2.89466 5.05926 2.67862 5.17075 2.48886C5.28225 2.2991 5.44227 2.14247 5.63438 2.03506C5.82832 1.92596 6.04788 1.87061 6.27037 1.87473C6.49286 1.87885 6.71022 1.94229 6.9 2.0585L18.1562 8.94443C18.3379 9.05418 18.488 9.20906 18.5921 9.39401C18.6961 9.57896 18.7505 9.78769 18.75 9.9999Z"
        />
      </g>
    </svg>
  );
}

export default PlayIconFlilled;
